import {useEffect, useState} from "react";

type ElapsedTime = {
    hours: number,
    minutes: number,
    seconds: number,
};

export function useElapsedTime(from: Date): ElapsedTime {
    const [, forceUpdate] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            forceUpdate((x) => x + 1);
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    const diffMs = Date.now() - from.getTime();

    const totalSeconds = Math.floor(diffMs / 1000);

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return {
        hours,
        minutes,
        seconds,
    };
}